import { z } from 'zod';
import { optionalReferenceIdSchema, requiredIntFromNumberInput } from '@/shared/utils/formZod.schema.utils';

export const distritoFormSchema = z
  .object({
    ordem: requiredIntFromNumberInput({
      requiredMessage: 'Informe a ordem',
      min: 0,
      minMessage: 'A ordem deve ser zero ou maior',
    }),
    nome: z.string().trim().min(1, 'Informe o nome do distrito'),
    defensoria: optionalReferenceIdSchema,
  })
  .passthrough();

export type DistritoFormValues = z.infer<typeof distritoFormSchema>;
